import {useDistanceToNow} from '../../../../../hooks/useTimeSelector'
import {useUserDisplayName} from '../../../../../hooks/useUserDisplayName'
import {getBuild} from '../../../../../selectors'
import BuildCommentByIcon from '../../../../common/BuildCommentByIcon/BuildCommentByIcon'

import type {Props} from './BuildStatusChange.types'

import {useAppSelector} from 'src/hooks/react-redux'

export default function BuildStatusChange({buildId}: Props) {
  const statusHasChanged = useAppSelector(
    state => getBuild(state, buildId)?.statusChangeComment != null,
  )
  const buildTypeId = useAppSelector(state => getBuild(state, buildId)?.buildType)
  const statusText = useAppSelector(state => {
    const status = getBuild(state, buildId)?.status ?? 'UNKNOWN'

    if (status === 'FAILURE') {
      return 'failed'
    }

    if (status === 'SUCCESS') {
      return 'successful'
    }
    return status
  })
  const user = useAppSelector(state => getBuild(state, buildId)?.statusChangeComment?.user)
  const userDisplayName = useUserDisplayName(user, true)
  const userText = userDisplayName != null ? ` by ${userDisplayName}` : ''
  const timestamp = useAppSelector(
    state => getBuild(state, buildId)?.statusChangeComment?.timestamp,
  )
  const timestampFromNow = useDistanceToNow(timestamp)

  const timestampText = timestampFromNow != null ? ` ${timestampFromNow}` : ''
  const commentText = useAppSelector(state => {
    const text = getBuild(state, buildId)?.statusChangeComment?.text
    return text != null ? `: ${text}` : 'manually'
  })
  return statusHasChanged ? (
    <BuildCommentByIcon
      buildTypeId={buildTypeId}
      text={`Marked as ${statusText}${userText}${timestampText}${commentText}`}
      inline
    />
  ) : null
}
